import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('customers-documents', storeModule.createStoreModule('customers-documents'))
